"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeStampsToJSON = exports.TimeStampsFromJSONTyped = exports.TimeStampsFromJSON = void 0;
function TimeStampsFromJSON(json) {
    return TimeStampsFromJSONTyped(json, false);
}
exports.TimeStampsFromJSON = TimeStampsFromJSON;
function TimeStampsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
    };
}
exports.TimeStampsFromJSONTyped = TimeStampsFromJSONTyped;
function TimeStampsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
    };
}
exports.TimeStampsToJSON = TimeStampsToJSON;
